import { PriceDisplayEnum, PriceDisplay } from 'src/areas/product/types';
import {
  PRICE_SHIPPING_DISPLAY,
  PRODUCT_VARIANT_SELECTED,
  PRODUCT_CONDITION_SELECTED,
  OFFER_SORTING,
} from '../actions/product';
import { Variant, ProductCondition } from '../../../types';
import {
  SortOption,
  SortOptionEnum,
} from '../components/price-list/offer-list-sorting/types';
import {
  getPriceDisplayFromUserSettings,
  getSortingFromUserSettings,
} from '../components/price-list/offer-list-filters/utils';

type State =
  | {
      campaigns: any[] | null;
      priceDisplay: PriceDisplay;
      sorting: SortOption;
      variant: Variant;
      condition: ProductCondition;
    }
  | undefined;

type Action =
  | {
      type: 'PRICE_SHIPPING_DISPLAY';
      priceDisplay: PriceDisplay;
    }
  | {
      type: 'PRODUCT_VARIANT_SELECTED';
      variant: Variant;
    }
  | {
      type: 'PRODUCT_CONDITION_SELECTED';
      condition: ProductCondition;
    }
  | {
      type: 'CAMPAIGNS_RECEIVE';
      campaigns: any[] | null;
    }
  | {
      type: 'OFFER_SORTING';
      sorting: SortOption;
    };

export const defaultProductState = {
  campaigns: null,
  variant: { id: 0 }, // variant.id === 0 corresponds to "all", which is set to default selected value here
  priceDisplay: PriceDisplayEnum.PRICE,
  sorting: SortOptionEnum.PRICE,
  condition: 'new' as ProductCondition,
};

const getProductState = () => {
  const state = { ...defaultProductState };
  state.priceDisplay =
    getPriceDisplayFromUserSettings() || defaultProductState.priceDisplay;
  state.sorting = getSortingFromUserSettings() || defaultProductState.sorting;
  return defaultProductState;
};

export default (state: State, action: Action) => {
  if (!state) {
    return getProductState();
  }

  switch (action.type) {
    case 'CAMPAIGNS_RECEIVE': {
      return {
        ...state,
        campaigns:
          action.campaigns &&
          action.campaigns.filter(campaign => campaign.state === 'ACTIVE'),
      };
    }

    case PRICE_SHIPPING_DISPLAY: {
      return {
        ...state,
        priceDisplay: action.priceDisplay,
      };
    }

    case PRODUCT_VARIANT_SELECTED: {
      return {
        ...state,
        variant: action.variant,
      };
    }

    case PRODUCT_CONDITION_SELECTED: {
      return {
        ...state,
        condition: action.condition,
      };
    }

    case OFFER_SORTING: {
      return {
        ...state,
        sorting: action.sorting,
      };
    }

    default:
      return state;
  }
};
